import React from "react";

import { COLOR } from "~/constants/colors";
import {
  OpenFolderIcon,
  SidebarFacilityIcon,
  SidebarMachinesIcon,
} from "~/icons/icons";

export const ANALYTICS_REPORT_ENTITIES = {
  WORK_ORDER: {
    TITLE_KEY: "workOrdersEntityText",
    ENTITY: "workOrder",
    ICON: <OpenFolderIcon strokeColor={COLOR.$gray_v2_60} />,
    ICON_ACTIVE: <OpenFolderIcon strokeColor={COLOR.$blue_v2_100} />,
  },
  CONNECTION: {
    TITLE_KEY: "connectionsEntityText",
    ENTITY: "facility",
    ICON: <SidebarFacilityIcon strokeColor={COLOR.$gray_v2_60} />,
    ICON_ACTIVE: <SidebarFacilityIcon strokeColor={COLOR.$blue_v2_100} />,
  },
  MACHINE: {
    TITLE_KEY: "machinesEntityText",
    ENTITY: "machine",
    ICON: <SidebarMachinesIcon strokeColor={COLOR.$gray_v2_60} />,
    ICON_ACTIVE: <SidebarMachinesIcon strokeColor={COLOR.$blue_v2_100} />,
  },
};

export const getAnalyticsReportEntity = () => {
  const filteredEntities = {};
  Object.keys(ANALYTICS_REPORT_ENTITIES).forEach((key) => {
    if (key === "CONNECTION") {
      filteredEntities[key] = ANALYTICS_REPORT_ENTITIES[key];
    }
    if (!["CONNECTION", "FACILITY"].includes(key)) {
      filteredEntities[key] = ANALYTICS_REPORT_ENTITIES[key];
    }
  });
  return filteredEntities;
};

export const ANALYTICS_CHART_TYPES = {
  HORIZONTAL_BAR: "horizontalBar",
  VERTICAL_BAR: "verticalBar",
  PIE: "pie",
  NUMBER: "number",
  TABLE: "table",
};

export const NO_VALUE_FILTERS = ["Is empty", "Is not empty"];

export const LABEL_LENGTH_LIMIT = 25;
